import dayjs from "dayjs";

const MIN_SEARCH_LEN = 1;

/** Only these company records are returned on the Companies List page. */
const COMPANIES_LIST_ALLOWED_STATUSES = ["approved", "deactivated"];

/**
 * Maps Companies List redux filters → GET /companies query.
 */
export function buildCompaniesListApiParams({ filters, pagination }) {
  const page = Number(pagination?.page) > 0 ? Number(pagination.page) : 1;
  const params = {
    page,
    items: pagination?.per_page,
    order_by_created_at: "desc",
  };

  const q = filters?.search?.trim() ?? "";
  if (q.length >= MIN_SEARCH_LEN) {
    params.name = q;
  }

  const st = filters?.status;
  let statuses = [];
  if (Array.isArray(st) && st.length > 0) {
    statuses = st.filter(
      (s) => s && COMPANIES_LIST_ALLOWED_STATUSES.includes(s)
    );
  }
  if (statuses.length === 0) {
    statuses = [...COMPANIES_LIST_ALLOWED_STATUSES];
  }
  params.status = statuses.join(",");

  if (filters?.created_at_start_date) {
    params.created_at_start_date = dayjs(
      filters.created_at_start_date
    ).format("YYYY-MM-DD");
  }
  if (filters?.created_at_end_date) {
    params.created_at_end_date = dayjs(filters.created_at_end_date).format(
      "YYYY-MM-DD"
    );
  }

  return params;
}
